"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViacomAccountPasswordService = exports.viacomAccountPasswordService = void 0;
var tslib_1 = require("tslib");
var auth_suite_fetch_1 = require("../../auth-suite-fetch");
var models_1 = require("../../models");
var requestRoute = "viacomAccount/password";
var forgotPassword = function (request) {
    var path = "".concat(requestRoute, "/forgot");
    var payload = {
        email: request.email,
    };
    var requestParams = [models_1.AuthSuiteRequestParams.ActivationCode];
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: path,
        request: request,
        requestParams: requestParams,
    });
};
var resetPassword = function (request) {
    var path = "".concat(requestRoute, "/reset");
    var payload = tslib_1.__assign({}, request);
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: path,
        request: request,
    });
};
var changePassword = function (request) {
    var path = "".concat(requestRoute, "/change");
    var payload = tslib_1.__assign({}, request);
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: path,
        request: request,
    });
};
var verifyPassword = function (request) {
    var path = "".concat(requestRoute, "/verify");
    var payload = tslib_1.__assign({}, request);
    var body = JSON.stringify(payload);
    return auth_suite_fetch_1.authSuiteFetchWithAuthorization.post({
        body: body,
        path: path,
        request: request,
    });
};
exports.viacomAccountPasswordService = {
    changePassword: changePassword,
    forgotPassword: forgotPassword,
    resetPassword: resetPassword,
    verifyPassword: verifyPassword
};
var ViacomAccountPasswordService = /** @class */ (function () {
    function ViacomAccountPasswordService() {
        return exports.viacomAccountPasswordService;
    }
    return ViacomAccountPasswordService;
}());
exports.ViacomAccountPasswordService = ViacomAccountPasswordService;
